module.exports = __webpack_public_path__ + "img/styles_background_mobile@2x.eb72d96.jpg";